import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authPost } from '../../utils/authApi';

const input = 'w-full border border-gray-300 rounded-lg px-4 py-3 text-gray-900 focus:outline-none focus:ring-2 focus:ring-green-500';

export default function PasswordAuthForm() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const switchMode = (m) => { setMode(m); setError(''); setNotice(''); };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError(''); setNotice('');
    try {
      if (mode === 'login') {
        await authPost('/login', { email: form.email, password: form.password });
        navigate('/dashboard');
      } else if (mode === 'register') {
        const r = await authPost('/register', form);
        setNotice(r.message);
      } else {
        const r = await authPost('/forgot-password', { email: form.email });
        setNotice(r.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  const label = { login: 'Log in', register: 'Create account', forgot: 'Send reset link' }[mode];
  return (
    <form onSubmit={submit} className="space-y-3" data-testid="password-auth-form">
      {mode !== 'forgot' && (
        <div className="grid grid-cols-2 gap-1 bg-gray-100 rounded-lg p-1 mb-2" role="tablist">
          {[['login', 'Log in'], ['register', 'Create account']].map(([m, t]) => (
            <button key={m} type="button" onClick={() => switchMode(m)} className={`py-2 rounded-md text-sm font-bold transition-colors ${mode === m ? 'bg-white text-gray-900 shadow' : 'text-gray-500'}`} data-testid={`auth-tab-${m}`}>{t}</button>
          ))}
        </div>
      )}
      {mode === 'forgot' && <p className="text-sm text-gray-600">Enter your email and we'll send you a link to choose a new password.</p>}
      {mode === 'register' && <input className={input} placeholder="Your name" value={form.name} onChange={set('name')} autoComplete="name" data-testid="auth-name-input" />}
      <input className={input} type="email" placeholder="Email" value={form.email} onChange={set('email')} required autoComplete="email" data-testid="auth-email-input" />
      {mode !== 'forgot' && (
        <input className={input} type="password" placeholder={mode === 'register' ? 'Password (8+ characters)' : 'Password'} value={form.password} onChange={set('password')} required minLength={mode === 'register' ? 8 : 1} autoComplete={mode === 'register' ? 'new-password' : 'current-password'} data-testid="auth-password-input" />
      )}
      {error && <p className="text-sm text-red-600" data-testid="auth-error">{error}</p>}
      {notice && <p className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-lg p-3" data-testid="auth-notice">{notice}</p>}
      <button type="submit" disabled={busy} className="w-full bg-gray-900 hover:bg-black text-white rounded-lg px-6 py-3 font-bold transition-colors disabled:opacity-60" data-testid="auth-submit-btn">
        {busy ? 'Please wait…' : label}
      </button>
      <div className="text-center text-sm">
        {mode === 'login' && <button type="button" onClick={() => switchMode('forgot')} className="text-green-700 hover:underline" data-testid="auth-forgot-link">Forgot password?</button>}
        {mode === 'forgot' && <button type="button" onClick={() => switchMode('login')} className="text-green-700 hover:underline" data-testid="auth-back-to-login">Back to log in</button>}
      </div>
    </form>
  );
}
